<template>
  <v-card class="modern-chart-card pa-4">
    <LineChartGenerator
      :chart-options="options"
      :chart-data="data"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="plugins"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </v-card>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 300,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
    },
  },
  data() {
    const vm = this;
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        borderColor: "#2563EB",
        backgroundColor: "rgba(37, 99, 235, 0.08)",
        tension: 0.4,
        elements: {
          point: {
            pointStyle: "circle",
            hoverBorderWidth: 3,
            hitRadius: 20,
            radius: 3,
            hoverRadius: 8,
            backgroundColor: "#2563EB",
          },
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              display: true,
              precision: 0,
              color: "#64748b",
            },
            grid: {
              drawBorder: false,
              color: "rgba(15, 23, 42, 0.05)",
            },
          },
          x: {
            ticks: {
              color: "#64748b",
            },
            grid: {
              display: false,
              drawBorder: false,
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            displayColors: false,
            callbacks: {
              title: function () {},
              label: function (items) {
                return vm.type === "REVENUE"
                  ? "$ " + items.dataset.data[items.dataIndex]
                  : "" + items.dataset.data[items.dataIndex];
              },
            },
            xAlign: "center",
            yAlign: "bottom",
            backgroundColor: "#1E293B",
            bodyColor: "#FFFFFF",
            padding: 10,
            cornerRadius: 8,
            bodyFont: {
              size: 14,
              weight: "bold",
            },
          },
        },
      },
    };
  },
};
</script>
<style scoped>
.modern-chart-card {
  border-radius: 14px !important;
  background: #ffffff !important;
  border: 1px solid rgba(15, 23, 42, 0.06);
  box-shadow: 0 2px 12px 0 rgba(15, 23, 42, 0.04) !important;
}
</style>
